import { Box, Grid } from '@material-ui/core'
import { useStyles } from './components/propaganda-resposta-style'
import { NovoIcon } from 'views/components/icons';
import { ButtonFab } from 'views/components/controles';
import { useCadastros, useSessaoAtual } from 'services/app';
import { EnumTipoPessoas } from 'model/enums/enum-tipo-pessoas';
import { AccordionDestinatarios } from './components/accordion-destinatarios/accordion-destinatarios';

interface PropagandaRespostasProps {
    propagandaId: string;
    revendaId?: string;
}

export const PropagandaResposta = (props: PropagandaRespostasProps) => {
    const classes = useStyles();
    const { abrirCadastroPropagandaResposta } = useCadastros();
    const { usuario, tipoUsuario } = useSessaoAtual();

    return (
        <Grid item xs={12}>
            <Box className={classes.defaultContainer}>
                <AccordionDestinatarios
                    isRespondidos={false}
                />
                <AccordionDestinatarios
                    isRespondidos={true}
                />

            </Box>
            <Grid className={classes.botaoAdicionar}>
                <ButtonFab
                    tooltip="Adicionar Resposta"
                    icon={<NovoIcon tipo="BUTTON_FAB" />}
                    onClick={() => {
                        abrirCadastroPropagandaResposta('', props.propagandaId, tipoUsuario() === EnumTipoPessoas.Revendedor ? usuario?.NomeComercial ?? '' : '')
                    }}
                />
            </Grid>
        </Grid>
    )
}